import { apiController } from './controller.api'
import { ResponseFacilitiesDto } from '§A/facility/dto/response-facilities.dto'
import { ResponseFacilityDto } from '§A/facility/dto/response-facility.dto'
import { CreateFacilityDto } from '§A/facility/dto/create-facility.dto'
import { UpdateFacilityDto } from '§A/facility/dto/update-facility.dto'
import { ConnectFacilityProjectDto } from '§A/facility/dto/connect-facility-project.dto'
import type { Uuid4 } from '§C/types/system.type'

const { controllerGet, controllerPost, controllerPatch, controllerDelete } = apiController('facilities')

export const apiFacility = {
  /**
   * Get all facilities for the current organization (via X-Organization-Id header)
   */
  facilityReadAll: async (): Promise<ResponseFacilitiesDto> => {
    return await controllerGet<ResponseFacilitiesDto>()
  },

  /**
   * Get a single facility by ID
   */
  facilityReadOne: async (facilityId: Uuid4): Promise<ResponseFacilityDto> => {
    return await controllerGet<ResponseFacilityDto>(facilityId)
  },

  /**
   * Create a new facility
   */
  facilityCreate: async (createDto: CreateFacilityDto): Promise<ResponseFacilityDto> => {
    return await controllerPost<CreateFacilityDto, ResponseFacilityDto>(createDto)
  },

  /**
   * Update an existing facility
   */
  facilityUpdate: async (facilityId: Uuid4, updateDto: UpdateFacilityDto): Promise<ResponseFacilityDto> => {
    return await controllerPatch<UpdateFacilityDto, ResponseFacilityDto>(updateDto, facilityId)
  },

  /**
   * Connect a facility to a project
   */
  facilityConnectToProject: async (facilityId: Uuid4, connectDto: ConnectFacilityProjectDto): Promise<ResponseFacilityDto> => {
    return await controllerPost<ConnectFacilityProjectDto, ResponseFacilityDto>(connectDto, `${facilityId}/projects`)
  },

  /**
   * Disconnect a facility from a project
   */
  facilityDisconnectFromProject: async (facilityId: Uuid4, projectId: Uuid4): Promise<ResponseFacilityDto> => {
    return await controllerDelete<ResponseFacilityDto>(`${facilityId}/projects/${projectId}`)
  }
}
